import PauseButton from './PauseButton';

export default PauseButton;
